import React, { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { Box, Card, Divider, Typography } from '@mui/material';
import { firestore } from '../../../../../contexts/FirebaseContext';
import { etiquetasCrece } from '../../../../../constants/crece/etiquetasCrece';

function Section7({ dataUser }) {
  const [loading, setLoading] = useState(false);
  const verifyTag = (tag) => {
    if (dataUser?.etiquetas?.includes(tag)) {
      return true;
    }
    return false;
  };

  // eslint-disable-next-line consistent-return
  const handleEtiqueta = async (etiqueta) => {
    setLoading(true);
    if (!dataUser?.etiquetas) {
      // console.log('si no tiene etiquetas');
      await firestore
        .collection('users')
        .doc(dataUser.id)
        .update({ etiquetas: [etiqueta] });

      setLoading(false);
    }
    if (verifyTag(etiqueta)) {
      // console.log('si la etiqueta enviada ya esta');

      // const newArr = dataUser?.etiquetas?.filter((tag) => tag === etiqueta);

      // console.log(newArr, etiqueta);
      await firestore
        .collection('users')
        .doc(dataUser.id)
        .update({ etiquetas: dataUser?.etiquetas?.filter((tag) => tag !== etiqueta) });

      setLoading(false);
    }
    if (!verifyTag(etiqueta)) {
      // console.log('si la etique aun no esta en el arr');
      await firestore
        .collection('users')
        .doc(dataUser.id)
        .update({ etiquetas: [...dataUser?.etiquetas, etiqueta] });

      setLoading(false);
    }
  };
  return (
    <Box>
      <Typography textAlign="center" variant="subtitle1">
        Acceso CRECE
      </Typography>
      <Divider />
      <Box sx={{ marginTop: '10px' }}>
        <Card
          sx={{ padding: '10px', display: 'flex', gap: '10px', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Typography variant="subtitle2">
            {verifyTag(etiquetasCrece.crece) ? 'Tiene acceso a CRECE' : 'No tiene acceso a CRECE'}
          </Typography>
          {verifyTag(etiquetasCrece.crece) ? (
            <LoadingButton
              loading={loading}
              onClick={() => handleEtiqueta(etiquetasCrece.crece)}
              variant="contained"
              color="info"
            >
              quitar acceso
            </LoadingButton>
          ) : (
            <LoadingButton
              loading={loading}
              onClick={() => handleEtiqueta(etiquetasCrece.crece)}
              variant="contained"
              color="info"
            >
              dar acceso
            </LoadingButton>
          )}
        </Card>
      </Box>
    </Box>
  );
}

export default Section7;
